import { COMPLETE } from '../constants/orders';

export const isComplete = status =>
  status === COMPLETE;

export default isComplete;
